import { render } from "./SnapchatRedirectView.vue?vue&type=template&id=08f20584"
import script from "./SnapchatRedirectView.vue?vue&type=script&lang=js"
export * from "./SnapchatRedirectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__